const getInitialComments = () => {
    return [];
};

const formatAttachmentName = (value, maxLength = 48) => {
    if (!value || value.length <= maxLength) {
        return value;
    }

    const dotIndex = value.lastIndexOf(".");
    if (dotIndex <= 0 || dotIndex === value.length - 1) {
        return `${ value.slice(0, maxLength - 3) }...`;
    }

    const extension = value.slice(dotIndex);
    const fileName = value.slice(0, dotIndex);
    const fileNameMax = maxLength - extension.length - 3;

    if (fileNameMax <= 0) {
        return `${ value.slice(0, maxLength - 3) }...`;
    }

    return `${ fileName.slice(0, fileNameMax) }...${ extension }`;
};

const formatDate = (value) => {
    if (!value) {
        return "";
    }

    const date = new Date(value);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return `${ day }.${ month }.${ year } | ${ hours }:${ minutes }`;
};

const CommentsListHelper = {
    getInitialComments,
    formatAttachmentName,
    formatDate,
};

export default CommentsListHelper;
